import React from 'react';
import { useAppSelector } from '../../utils/storeHooks';
import FadeScreen from './FadeScreen';

const Modal = () => {

    const { modal } = useAppSelector((store) => store.display);
    return modal && <FadeScreen />

}

export default Modal